<nav class="navbar navbar-expand-lg py-3 navbar-dark bg-dark shadow-sm">
    <div class="container">
        <a href="#" class="navbar-brand">
            <img src="{{company.logo_url}}" width="70" alt="{{company.name}}" title="{{company.name}}"
                class="d-inline-block align-middle mr-2">
            <span>Comprobante de Pago Electrónico</span>
        </a>
    </div>
</nav>